<template>
	<div :class="[companyClass, canScroll]">
		<div class="page-addtariff flex column  mb-20">
			<div class="page-header">
				<h1 class="pageTitle">Add tariff</h1>
				<h4>create tariff </h4>
				<el-breadcrumb separator="/">
					<el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
					<el-breadcrumb-item>settings</el-breadcrumb-item>
					<el-breadcrumb-item>tariffs</el-breadcrumb-item>
					<el-breadcrumb-item>add tariff</el-breadcrumb-item>
				</el-breadcrumb>
			</div>

			<div class="mt-0 w-100">
				<div style="float: right;">
					<el-button type="warning" icon="el-icon-tickets" @click="viewTariffs"></el-button>
				</div>
			</div>

			<div class="mt-10">
				<el-row :gutter="20">
					<el-col :span="8">
						<span>Sending Country</span><span :class="required"> *</span>
						<el-select v-model="tariff.fromCountryID" filterable placeholder="Select sender country"
							class="mb-10" style="width:100%" name="scountry" v-validate="'required'" readonly disabled
							data-vv-as="sending country">
							<el-option v-for="country in userCountries" :key="country.id" :label="country.name"
								:value="country.id">
							</el-option>
						</el-select>
						<transition name="fade">
							<span class="danger-text">{{ errors.first('scountry') }}</span>
						</transition>
					</el-col>
					<el-col :span="8">
						<span>Receiving Country</span><span :class="required"> *</span>
						<el-select v-model="tariff.toCountryID" filterable placeholder="Select receiving country"
							class="mb-10" style="width:100%" name="rcountry" v-validate="'required'"
							data-vv-as="receiving country">
							<el-option v-for="country in companyRegions" :key="country.id" :label="country.name"
								:value="country.id"></el-option>
						</el-select>
						<transition name="fade">
							<span class="danger-text">{{ errors.first('rcountry') }}</span>
						</transition>
					</el-col>
					<el-col :span="8">
						<span>Service Type</span><span :class="required"> *</span>
						<el-select v-model="tariff.serviceTypeID" filterable placeholder="Select Service Type" class="mb-10"
							style="width:100%" name="servicetype" v-validate="'required'" data-vv-as="service type">
							<el-option v-for="sType in serviceTypes" :key="sType.id" :label="sType.name" :value="sType.id">
							</el-option>
						</el-select>
						<transition name="fade">
							<span class="danger-text">{{ errors.first('servicetype') }}</span>
						</transition>
					</el-col>
				</el-row>

				<el-row :gutter="20">
					<el-col :span="8">
						<span>Tariff Type</span><span :class="required"> *</span>
						<el-select v-model="tariff.tranctionFeeTypeStr" filterable placeholder="Select tariff type"
							class="mb-10" style="width:100%" name="tarifftype" v-validate="'required'"
							data-vv-as="sending tariff type">
							<el-option v-for="ttype in tarifftypes" :key="ttype" :label="ttype" :value="ttype">
							</el-option>
						</el-select>
						<transition name="fade">
							<span class="danger-text">{{ errors.first('tarifftype') }}</span>
						</transition>
					</el-col>
					<el-col :span="8">
						<span>From Transaction Amount</span><span :class="required"> *</span>
						<el-input placeholder="From Amount" v-model="tariff.fromAmount" name="fromamount"
							v-validate="'required|decimal:5'" data-vv-as="from amount"></el-input>
						<transition name="fade">
							<span class="danger-text">{{ errors.first('fromamount') }}</span>
						</transition>
					</el-col>
					<el-col :span="8">
						<span>To Transaction Amount</span><span :class="required"> *</span>
						<el-input placeholder="To Amount" v-model="tariff.toAmount" name="toamount"
							v-validate="'required|decimal:5'" data-vv-as="to amount"></el-input>
						<transition name="fade">
							<span class="danger-text">{{ errors.first('toamount') }}</span>
						</transition>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :span="8">
						<span>Tariff Amount</span><span :class="required"> *</span>
						<el-input placeholder="Tariff Amount" v-model="tariff.amount" name="tariffamount"
							v-validate="'required|decimal:5'" data-vv-as="tariff amount"></el-input>
						<transition name="fade">
							<span class="danger-text">{{ errors.first('tariffamount') }}</span>
						</transition>
					</el-col>
					<!-- <el-col :span="8">
							<span>User Type</span><span :class="required"> *</span>
							<el-select v-model="tariff.userType" filterable placeholder="Select tariff user type" class="mb-10"
							style="width:100%" name="tariffusertype" v-validate="'required'" data-vv-as="sending tariff user type">
								<el-option
								v-for="tutype in tariffUserTypes"
								:key="tutype"
								:label="tutype"
								:value="tutype">
								</el-option>
							</el-select>
						</el-col> -->
					<el-col :span="8">
						<span>Transaction Type</span><span :class="required"> *</span>
						<el-select v-model="tariff.transactionTypeId" filterable placeholder="Select tariff user type"
							class="mb-10" style="width:100%" name="tariffusertype" v-validate="'required'"
							data-vv-as="sending tariff user type">
							<el-option v-for="tt in transactionTypes" :key="tt.Id" :label="tt.Name" :value="tt.Id">
							</el-option>
						</el-select>
					</el-col>
					<el-col :span="8" v-if="tariff.tranctionFeeTypeStr == 'Percentage'">
						<span>Ceiling Amount</span><span :class="required"> *</span>
						<el-input placeholder="Ceiling Amount" v-model="tariff.ceilingAmount" name="ceilingamount"
							v-validate="'required|decimal:5'" data-vv-as="ceiling amount"></el-input>
						<transition name="fade">
							<span class="danger-text">{{ errors.first('ceilingamount') }}</span>
						</transition>
					</el-col>
				</el-row>

				<el-row :gutter="20" class="mt-10">
					<el-col :span="8">
						<span>Activate Notifications</span>
						<el-checkbox class="w-100" v-model="tariff.notificationActive" border>Send a notification on
							expiring</el-checkbox>
					</el-col>
					<el-col :span="8" v-show="tariff.notificationActive">
						<span>Timespan before expiring</span>
						<el-input placeholder="Timespan" v-model="tariff.timespan"></el-input>
					</el-col>
					<el-col :span="8" v-show="tariff.notificationActive">
						<span>Timespan Type</span>
						<el-select v-model="tariff.timeSpanType" filterable clearable placeholder="Timespan Type"
							class="mb-10" style="width:100%">
							<el-option v-for="tframe in timeframes" :key="tframe.value" :label="tframe.label"
								:value="tframe.value">
							</el-option>
						</el-select>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="mt-10" v-show="tariff.notificationActive">
					<el-col :span="12">
						<span>Mobile Number Alerts</span>
						<el-input v-model="tariff.notificationPhoneNumbers" type="textarea" :rows="2"
							placeholder="Enter mobile number separated by a comma"></el-input>
					</el-col>
					<el-col :span="12">
						<span>Email Alerts</span>
						<el-input v-model="tariff.notificationEmails" type="textarea" :rows="2"
							placeholder="Enter email addresses separated by a comma"></el-input>
					</el-col>
				</el-row>

				<div class="mt-10">
					<el-button type="primary" @click="checkValidAndSave"><i></i> Save Tariff</el-button>
					<el-button type="info" @click="clearState"><i></i> Reset</el-button>
				</div>
			</div>

		</div>
	</div>
</template>


<script>
import ApiServiceMixin from '@/mixins/ApiServiceMixin'
import MessagesMixin from '@/mixins/MessagesMixins'
import UtilitiesMixin from '@/mixins/UtilitiesMixin'
import router from '@/router/'
import { bus } from '@/main'
import { Validator } from 'vee-validate'

export default {
	name: 'AddTariff',
	data() {
		return {
			tarifftypes: ['Fixed', 'Percentage'],
			tariffUserTypes: ['Individual', 'Company'],
			company: [],
			userCountries: [],
			transactionTypes: [
				{
					Id: 1,
					Name: "C2C"
				},
				{
					Id: 2,
					Name: "C2B"
				},
				{
					Id: 3,
					Name: "B2B"
				},
				{
					Id: 4,
					Name: "B2C"
				}
			],
			tariff: {
				id: 0,
				companyID: 0,
				fromCountryID: '',
				toCountryID: '',
				serviceTypeID: '',
				fromAmount: '',
				toAmount: '',
				tranctionFeeTypeStr: '',
				amount: '',
				notificationActive: false,
				timespan: 0,
				timeSpanType: '',
				notificationPhoneNumbers: '',
				notificationEmails: '',
				userType: '',
				transactionTypeId: '',
				ceilingAmount: ''
			}
		}
	},
	methods: {
		viewTariffs() {
			router.push('/tariffs');
		},
		clearState() {
			this.tariff = {
				id: 0,
				companyID: 0,
				fromCountryID: '',
				toCountryID: '',
				serviceTypeID: '',
				fromAmount: '',
				toAmount: '',
				tranctionFeeTypeStr: '',
				amount: '',
				notificationActive: false,
				timespan: 0,
				timeSpanType: '',
				notificationPhoneNumbers: '',
				notificationEmails: ''
			};
			this.$validator.reset();
		},
		checkValidAndSave() {
			let self = this;
			this.$validator.validateAll()
				.then(result => {
					if (result) {
						this.saveTariff(self.tariff)
							.then(result => {
								if (result.id > 0) {
									self.tariff = result;
									self.clearState();
									this.successMessage('Tariff saved successfully.');
								}
								else {
									this.errorMessage(`Tariff not saved. ${result.errors[0]}`);
								}
							})
							.catch(err => this.errorMessage('An error occured.'));
					}
				})
				.catch(err => console.log(err));
		},
		setCurrent() {
			var id = router.currentRoute.params.id;

			this.pageTitle = 'Add Tariff';
			this.pageSubtitle = 'create tariff';

			if (id) {
				this.canDelete = true;
				this.pageTitle = 'update tariff info';
				this.findTariffByID(id)
					.then(result => {
						this.tariff = result;
						this.pageSubtitle = `update ${result.fromCountryName} - ${result.toCountryName}'s tariff info`;
					});
			}
		}
	},
	created() {
		this.getLoggedInCompany().then((loggedInCompany) => {
			this.company = loggedInCompany;
			this.tariff.companyID = this.company.id;
			this.getUserOperationalCountries().then((opcntry) => {
				this.userCountries = opcntry;
				this.tariff.fromCountryID = this.company.countryID;
			});
			this.getOperationalCountries();
			this.getServices();

			this.setCurrent();
		});
	},
	mixins: [ApiServiceMixin, MessagesMixin, UtilitiesMixin]
}
</script>

<style lang="scss" scoped></style>